// Tâche 1142 (Eric 2026-06-16) — Avertissement « alignement approximatif ».
//
// Quand aucune clé OpenAI n'est configurée, la transcription est produite par
// Gemini, qui ne renvoie PAS d'horodatage par mot. Knoria en fabrique un au
// prorata de la longueur des mots : suffisant pour lire et pour cliquer, mais
// pas au mot près. Le dire est le minimum : un lecteur synchronisé qui décale
// sans explication passe pour un bogue.
import React from "react";
import { Warning } from "@phosphor-icons/react";

export default function TranscriptionProviderNotice({ video }) {
  const provider = video?.transcription_provider;
  const approximate = !!video?.word_timestamps_approximate;
  if (provider !== "gemini" && !approximate) return null;
  const model = video?.transcription_provider_model;
  return (
    <div
      data-testid="transcription-provider-notice"
      data-provider={provider || "inconnu"}
      role="status"
      className="mb-4 flex items-start gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3"
    >
      <Warning size={20} className="mt-0.5 shrink-0 text-amber-400" />
      <div className="text-sm text-amber-100">
        <p className="font-semibold">
          Transcription produite par Gemini
          {model ? ` (${model})` : ""} — alignement mot à mot approximatif
        </p>
        <p className="mt-1 text-amber-200/80">
          Aucune clé OpenAI n'était configurée : Gemini a pris le relais. Le
          texte et le découpage en phrases sont fiables, mais la position de
          chaque mot est estimée, pas mesurée. Le lecteur synchronisé, les
          verrous de passage et les extraits de scripts peuvent donc décaler de
          quelques secondes. Ajoutez une clé OpenAI dans « Forfait AI » puis
          relancez la transcription pour un horodatage exact.
        </p>
      </div>
    </div>
  );
}
